import React from 'react';
import PropTypes from 'prop-types';

import AbstractWithFallback from './AbstractWithFallback';
import ImgNS from './ImgNS';

export default class ImgNSWithFallback extends AbstractWithFallback {
  static propTypes = {
    src        : PropTypes.string,
    fallbackSrc: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    alt        : PropTypes.string,
  };

  render() {
    const { src, fallbackSrc, alt, ...rest } = this.props;

    return <ImgNS src={this.state.src} alt={alt} {...rest} onError={this.onError} />;
  }
}
